import React from "react";
import { NavLink } from "react-router-dom";
import { Mic, Inbox, CalendarRange, User as UserIcon } from "lucide-react";

const tabs = [
  { to: "/", label: "Capture", icon: Mic, testid: "tab-capture", end: true },
  { to: "/inbox", label: "Inbox", icon: Inbox, testid: "tab-inbox" },
  { to: "/ahead", label: "Ahead", icon: CalendarRange, testid: "tab-ahead" },
  { to: "/account", label: "You", icon: UserIcon, testid: "tab-settings" },
];

// Mobile-only bottom tab bar. Desktop keeps the sidebar.
export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[var(--nav-bg)] backdrop-blur-md border-t border-[var(--line)] bottom-nav-safe"
    >
      <div className="flex items-stretch justify-around px-1.5 pt-1.5">
        {tabs.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 flex-1 min-h-[48px] rounded-xl pt-1.5 pb-1 transition-colors duration-200 ${
                isActive ? "text-[var(--pine)]" : "text-[var(--ink4)]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className={`flex items-center justify-center h-7 w-12 rounded-full transition-colors duration-200 ${
                    isActive ? "bg-[var(--pine-soft)]" : "bg-transparent"
                  }`}
                >
                  <Icon size={19} strokeWidth={isActive ? 2.1 : 1.75} />
                </span>
                <span className={`text-[10px] leading-none ${isActive ? "font-bold" : "font-medium"}`}>
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
